import prosiebensat1Logo from '../assets/prosiebensat1-logo.svg';
import justFriendsLogo from '../assets/just-friends-logo.jpg';

export const defaultBranding = {
  key: 'prosiebensat1',
  companyName: 'ProSiebenSat.1 Media SE',
  shortName: 'ProSiebenSat.1',
  logoKey: 'prosiebensat1',
  primaryColor: '#ec003f',
  imprintUrl: 'https://www.prosiebensat1.com/impressum-datenschutz/impressum',
  privacyUrl: 'https://www.prosiebensat1.com/impressum-datenschutz/datenschutz-hinweise'
};

const logos = {
  prosiebensat1: prosiebensat1Logo,
  'just-friends': justFriendsLogo
};

export const resolveBranding = (branding = {}) => ({
  ...defaultBranding,
  ...branding,
  imprintUrl: branding.imprintUrl || defaultBranding.imprintUrl,
  privacyUrl: branding.privacyUrl || defaultBranding.privacyUrl,
  logo: logos[branding.logoKey] || prosiebensat1Logo
});